import React from "react";

import { formatLorryCapacityRangeLabel } from "./getLorryVehicleRestriction";
import { VEHICLE_RESTRICTION_BANNER, VehicleRestrictionKind, VehicleRestrictionPopupConfig } from "./types";

function CapacityRangeText({ prefix, rangeLabel }: { prefix: string; rangeLabel?: string }) {
    return (
        <>
            {prefix} <strong>{rangeLabel || formatLorryCapacityRangeLabel()}</strong>
        </>
    );
}

export function getVehicleRestrictionPopupConfig(
    kind: VehicleRestrictionKind,
    options?: { capacityRangeLabel?: string }
): VehicleRestrictionPopupConfig {
    const rangeLabel = options?.capacityRangeLabel;

    switch (kind) {
        case "capacity_activate":
            return {
                kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.RANGE_NOT_ALLOWED,
                title: "Vehicle not supported",
                description: (
                    <CapacityRangeText prefix="We only support vehicles with capacity" rangeLabel={rangeLabel} />
                ),
                cancelLabel: "Cancel",
                primaryLabel: "Add New Vehicle"
            };
        case "capacity_reactivate":
            return {
                kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.RANGE_NOT_ALLOWED,
                title: "Vehicle not supported anymore",
                description: (
                    <CapacityRangeText prefix="We now only support vehicles with capacity" rangeLabel={rangeLabel} />
                ),
                cancelLabel: "Cancel",
                primaryLabel: "Add New Vehicle"
            };
        case "three_wheeler_lorry":
            return {
                kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.VEHICLE_NOT_ALLOWED,
                title: "This vehicle is not supported",
                description: "We do not support 3 wheeler LCVs. Please add another vehicle.",
                cancelLabel: "Cancel",
                primaryLabel: "Add New Vehicle"
            };
        case "three_wheeler_load_repost":
            return {
                kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.VEHICLE_NOT_ALLOWED,
                title: "This vehicle is not supported",
                description: "We do not support 3 wheeler LCVs.",
                cancelLabel: "Cancel",
                primaryLabel: "Edit & Post Load"
            };
        case "unsupported_category":
            return {
                kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.VEHICLE_NOT_ALLOWED,
                title: "This vehicle is not supported",
                description: "We no longer support Tanker, Hyva & Trailer.",
                cancelLabel: "Cancel",
                primaryLabel: "Add New Vehicle"
            };
    }
}
